import { createPersistedStore } from "./createPersistedStore";

// US 922643: the user's 12/24-hour clock preference, mirroring EAM web
// (sy_user_setup options/time_format, falling back to the TimeFormat EAM
// option, then 12h), and the user's date format (options/date_format, default
// MM/DD/YYYY). Persisted so offline launches keep the last known values.
// Read them through util/DateHelper or hooks/useTimeFormat, never directly.
export type TimeFormat = "12h" | "24h";

// The values EAM web's Edit Preferences saves for date format.
export type DateFormat =
  | "MM/DD/YYYY"
  | "MM-DD-YYYY"
  | "DD/MM/YYYY"
  | "DD-MM-YYYY"
  | "YYYY-MM-DD";

type TimeFormatState = {
  timeFormat: TimeFormat;
  dateFormat: DateFormat;
};

type TimeFormatAction = {
  setTimeFormat: (timeFormat: TimeFormat) => void;
  setDateFormat: (dateFormat: DateFormat) => void;
};

const defaultState: TimeFormatState = {
  timeFormat: "12h",
  dateFormat: "MM/DD/YYYY",
};

export const useTimeFormatStore = createPersistedStore<
  TimeFormatState,
  TimeFormatAction
>(
  defaultState,
  (set) => ({
    setTimeFormat(timeFormat) {
      set((state: any) => {
        state.timeFormat = timeFormat;
      });
    },
    setDateFormat(dateFormat) {
      set((state: any) => {
        state.dateFormat = dateFormat;
      });
    },
  }),
  "timeFormat",
  (state) => ({
    timeFormat: state.timeFormat,
    dateFormat: state.dateFormat,
  })
);
